// dateRange 天数
const genDateRangePickerOptions = (dateRange = 1, startDate = Date.now()) => {
  const dayMillisecond = 86400000
  const timeRange = dateRange * dayMillisecond
  let _minDate = null
  let _onPicking = false
  return {
    disabledDate(time) {
      const pickerTime = time.getTime()
      const enableMaxDate = startDate
      const pickedDate = _minDate ? _minDate.getTime() : null
      // 如果选择了一个日期，根据选择的日期算可选范围
      if (_onPicking) {
        return (
          pickerTime > Math.min(enableMaxDate, pickedDate + timeRange) ||
          pickerTime < pickedDate - timeRange
        )
      }
      // 初始化状态
      return pickerTime > enableMaxDate
    },
    onPick({ maxDate, minDate }) {
      // 记录是否是正在选择
      _onPicking = !maxDate
      // 记录第一次选择的那个时间，方便计算前后时间范围
      _minDate = minDate
    },
  }
}

export default genDateRangePickerOptions
